import {
    CommandResponse,
    EntityCommandCreateResponse,
    RevisionedCommandResponse,
    StudyEntityType,
    StudySegment,
    StudySegmentModification,
    toStudySegment,
} from '@faro/study-designer-model';
import axios from 'axios';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { StudyPathParameter } from '../parameter';

const factory = createStudyEntityHookFactory<StudySegment>(StudyEntityType.StudySegment);

export const useStudySegments = factory.list(
    (
        { studyId, ...query }: StudyPathParameter & { revision?: number },
        signal?: AbortSignal
    ): Promise<StudySegment[]> => {
        return axios
            .get(`/api/study-designer/studies/${studyId}/study-segments`, {
                signal,
                params: query,
            })
            .then(response => response.data?.map(toStudySegment) ?? []);
    }
);

export const useStudySegmentInsert = factory.mutate(
    (entity: Partial<StudySegmentModification>): Promise<RevisionedCommandResponse<EntityCommandCreateResponse>> => {
        const { studyId, ...body } = entity;
        return axios
            .post(`/api/study-designer/studies/${studyId}/study-segments`, body)
            .then(response => response.data);
    }
);

export const useStudySegmentUpdate = factory.mutate(
    (entity: StudySegment): Promise<RevisionedCommandResponse<CommandResponse>> => {
        return axios
            .put(`/api/study-designer/studies/${entity.studyId}/study-segments/${entity.id}`, entity)
            .then(response => response.data);
    },
    {
        optimisticUpdate: (segment, optimisticData) => {
            return optimisticData.map(x => (x.id === segment.id ? segment : x));
        },
    }
);

export const useStudySegmentDelete = factory.mutate(
    (entity: { id: string; studyId: string }): Promise<RevisionedCommandResponse<CommandResponse>> => {
        return axios
            .delete(`/api/study-designer/studies/${entity.studyId}/study-segments/${entity.id}`)
            .then(response => response.data);
    }
);
